import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styles from './style';
import Message from './message';


class Toaster extends Component {
  constructor(props) {
    super(props);
    this.state = {
      options: [],
      id: 0,
    };
    this.doToaster = this.doToaster.bind(this);
    this.rmMsg = this.rmMsg.bind(this);
  }
  doToaster(type, ctext, ctime) {
    const arr = { text: ctext, msgtype: type, time: ctime };
    this.toaster(arr);
  }
  remove(arr, id) {
    this.arr = arr;
    for (let i = 0; i < arr.length; i++) {
      if (arr[i].id === id) {
        arr.splice(i, 1);
      }
    }
    return arr;
  }
  toaster(arr) {
    const Newid = this.state.id + 1;
    arr.id = Newid;
    const newOptions = this.state.options;
    newOptions.push(arr);
    this.setState({ id: Newid });
    this.setState({ options: newOptions });
  }
  rmMsg(key) {
    const newOptions = this.state.options;
    const newarr = this.remove(newOptions, key);
    this.setState({ options: newarr });
  }
  render() {
    return (
      <div style={styles.container} >
        <Message options={this.state.options} callbackRM={this.rmMsg} />
      </div>
    );
  }
}

Toaster.propTypes = {
  style: PropTypes.shape({})
};

Toaster.defaultProps = {
  style: {}
};

export default Toaster;



// WEBPACK FOOTER //
// ./src/Components/Toaster/toaster.js